window.SHIPPING_RATES = [
  { min: 0.01, max: 0.50, standard: 6.713, silver: 6.04, gold: 4.70 },
  { min: 0.50, max: 1.00, standard: 9.166, silver: 8.25, gold: 6.42 },
  { min: 1.00, max: 1.50, standard: 11.799, silver: 10.62, gold: 8.26 },
  { min: 1.50, max: 2.00, standard: 14.252, silver: 12.83, gold: 9.98 },
  { min: 2.00, max: 2.50, standard: 16.705, silver: 15.03, gold: 11.69 },
  { min: 2.50, max: 3.00, standard: 19.358, silver: 17.42, gold: 13.55 },
  { min: 3.00, max: 3.50, standard: 23.831, silver: 21.45, gold: 16.68 },
  { min: 3.50, max: 4.00, standard: 27.064, silver: 24.36, gold: 18.94 },
  { min: 4.00, max: 4.50, standard: 30.297, silver: 27.27, gold: 21.21 },
  { min: 4.50, max: 5.00, standard: 33.530, silver: 30.18, gold: 23.47 },
  { min: 5.00, max: 5.50, standard: 37.863, silver: 34.08, gold: 26.50 },
  { min: 5.50, max: 6.00, standard: 41.236, silver: 37.11, gold: 28.87 },
  { min: 6.00, max: 6.50, standard: 44.609, silver: 40.15, gold: 31.23 },
  { min: 6.50, max: 7.00, standard: 47.982, silver: 43.18, gold: 33.59 },
  { min: 7.00, max: 7.50, standard: 51.355, silver: 46.22, gold: 35.95 },
  { min: 7.50, max: 8.00, standard: 50.148, silver: 45.13, gold: 35.10 },
  { min: 8.00, max: 8.50, standard: 58.101, silver: 52.29, gold: 40.67 },
  { min: 8.50, max: 9.00, standard: 61.474, silver: 55.33, gold: 43.03 },
  { min: 9.00, max: 9.50, standard: 64.847, silver: 58.36, gold: 45.39 },
  { min: 9.50, max: 10.00, standard: 68.220, silver: 61.40, gold: 47.75 },
  { min: 10.00, max: 10.50, standard: 71.593, silver: 64.43, gold: 50.12 },
  { min: 10.50, max: 11.00, standard: 74.966, silver: 67.47, gold: 52.48 },
  { min: 11.00, max: 11.50, standard: 78.339, silver: 70.51, gold: 54.84 },
  { min: 11.50, max: 12.00, standard: 81.712, silver: 73.54, gold: 57.20 },
  { min: 12.00, max: 12.50, standard: 85.085, silver: 76.58, gold: 59.56 },
  { min: 12.50, max: 13.00, standard: 88.058, silver: 79.25, gold: 61.64 },
  { min: 13.00, max: 13.50, standard: 91.591, silver: 82.43, gold: 64.11 },
  { min: 13.50, max: 14.00, standard: 90.284, silver: 81.26, gold: 63.20 },
  { min: 14.00, max: 14.50, standard: 98.577, silver: 88.72, gold: 69.00 },
  { min: 14.50, max: 15.00, standard: 101.950, silver: 91.76, gold: 71.36 },
  { min: 15.00, max: 15.50, standard: 105.323, silver: 94.79, gold: 73.73 },
  { min: 15.50, max: 16.00, standard: 108.696, silver: 97.83, gold: 76.09 },
  { min: 16.00, max: 16.50, standard: 112.069, silver: 100.86, gold: 78.45 },
  { min: 16.50, max: 17.00, standard: 115.442, silver: 103.90, gold: 80.81 },
  { min: 17.00, max: 17.50, standard: 118.815, silver: 106.93, gold: 83.17 },
  { min: 17.50, max: 18.00, standard: 122.188, silver: 109.97, gold: 85.53 },
  { min: 18.00, max: 18.50, standard: 125.561, silver: 113.00, gold: 87.89 },
  { min: 18.50, max: 19.00, standard: 128.934, silver: 116.04, gold: 90.25 },
  { min: 19.00, max: 19.50, standard: 132.307, silver: 119.08, gold: 92.61 },
  { min: 19.50, max: 20.00, standard: 137.740, silver: 123.97, gold: 96.42 },
  { min: 20.00, max: 21.00, standard: 144.186, silver: 129.77, gold: 100.93 },
  { min: 21.00, max: 22.00, standard: 151.112, silver: 136.00, gold: 105.78 },
  { min: 22.00, max: 23.00, standard: 158.038, silver: 142.23, gold: 110.63 },
  { min: 23.00, max: 24.00, standard: 164.964, silver: 148.47, gold: 115.47 },
  { min: 24.00, max: 25.00, standard: 171.890, silver: 154.70, gold: 120.32 },
  { min: 25.00, max: 26.00, standard: 178.816, silver: 160.93, gold: 125.17 },
  { min: 26.00, max: 27.00, standard: 185.742, silver: 167.17, gold: 130.02 },
  { min: 27.00, max: 28.00, standard: 192.668, silver: 173.40, gold: 134.87 },
  { min: 28.00, max: 29.00, standard: 199.594, silver: 179.63, gold: 139.72 },
  { min: 29.00, max: 30.00, standard: 206.520, silver: 185.87, gold: 144.56 },
  { min: 30.00, max: 31.00, standard: 213.446, silver: 192.10, gold: 149.41 },
  { min: 31.00, max: 32.00, standard: 220.372, silver: 198.33, gold: 154.26 },
  { min: 32.00, max: 33.00, standard: 227.298, silver: 204.57, gold: 159.11 },
  { min: 33.00, max: 34.00, standard: 234.224, silver: 210.80, gold: 163.96 },
  { min: 34.00, max: 35.00, standard: 241.150, silver: 217.03, gold: 168.81 },
  { min: 35.00, max: 36.00, standard: 248.076, silver: 223.27, gold: 173.65 },
  { min: 36.00, max: 37.00, standard: 255.002, silver: 229.50, gold: 178.50 },
  { min: 37.00, max: 38.00, standard: 261.928, silver: 235.74, gold: 183.35 },
  { min: 38.00, max: 39.00, standard: 268.854, silver: 241.97, gold: 188.20 },
  { min: 39.00, max: 40.00, standard: 275.780, silver: 248.20, gold: 193.05 },
  { min: 40.00, max: 41.00, standard: 282.706, silver: 254.44, gold: 197.89 },
  { min: 41.00, max: 42.00, standard: 289.632, silver: 260.67, gold: 202.74 },
  { min: 42.00, max: 43.00, standard: 296.558, silver: 266.90, gold: 207.59 },
  { min: 43.00, max: 44.00, standard: 303.484, silver: 273.14, gold: 212.44 },
  { min: 44.00, max: 45.00, standard: 310.410, silver: 279.37, gold: 217.29 },
  { min: 45.00, max: 46.00, standard: 317.336, silver: 285.60, gold: 222.14 },
  { min: 46.00, max: 47.00, standard: 324.262, silver: 291.84, gold: 226.98 },
  { min: 47.00, max: 48.00, standard: 331.188, silver: 298.07, gold: 231.83 },
  { min: 48.00, max: 49.00, standard: 338.114, silver: 304.30, gold: 236.68 },
  { min: 49.00, max: 50.00, standard: 345.040, silver: 310.54, gold: 241.53 },
  { min: 50.00, max: 51.00, standard: 351.966, silver: 316.77, gold: 246.38 },
  { min: 51.00, max: 52.00, standard: 358.892, silver: 323.00, gold: 251.22 },
  { min: 52.00, max: 53.00, standard: 365.818, silver: 329.24, gold: 256.07 },
  { min: 53.00, max: 54.00, standard: 372.744, silver: 335.47, gold: 260.92 },
  { min: 54.01, max: 55.00, standard: 368.670, silver: 331.80, gold: 258.07 },
  { min: 55.01, max: 56.00, standard: 375.400, silver: 337.86, gold: 262.78 },
  { min: 56.01, max: 57.00, standard: 382.120, silver: 343.91, gold: 267.48 },
  { min: 57.01, max: 58.00, standard: 388.850, silver: 349.97, gold: 272.19 },
  { min: 58.01, max: 59.00, standard: 395.570, silver: 356.01, gold: 276.90 },
  { min: 59.01, max: 60.00, standard: 402.300, silver: 362.07, gold: 281.61 },
  { min: 60.01, max: 61.00, standard: 409.030, silver: 368.13, gold: 286.32 },
  { min: 61.01, max: 62.00, standard: 415.750, silver: 374.18, gold: 291.02 },
  { min: 62.01, max: 63.00, standard: 422.480, silver: 380.23, gold: 295.74 },
  { min: 63.01, max: 64.00, standard: 429.200, silver: 386.28, gold: 300.44 },
  { min: 64.01, max: 65.00, standard: 435.930, silver: 392.34, gold: 305.15 },
  { min: 65.01, max: 66.00, standard: 442.660, silver: 398.39, gold: 309.86 },
  { min: 66.01, max: 67.00, standard: 449.380, silver: 404.44, gold: 314.57 },
  { min: 67.01, max: 68.00, standard: 456.110, silver: 410.50, gold: 319.28 },
  { min: 68.01, max: 69.00, standard: 462.830, silver: 416.55, gold: 323.98 },
  { min: 69.01, max: 70.00, standard: 469.560, silver: 422.60, gold: 328.69 },
  { min: 70.01, max: 71.00, standard: 476.290, silver: 428.66, gold: 333.40 },
  { min: 71.01, max: 72.00, standard: 483.010, silver: 434.71, gold: 338.11 },
  { min: 72.01, max: 73.00, standard: 489.740, silver: 440.77, gold: 342.82 },
  { min: 73.01, max: 74.00, standard: 496.460, silver: 446.81, gold: 347.52 },
  { min: 74.01, max: 75.00, standard: 503.190, silver: 452.87, gold: 352.23 },
  { min: 75.01, max: 76.00, standard: 509.920, silver: 458.93, gold: 356.94 },
  { min: 76.01, max: 77.00, standard: 516.640, silver: 464.98, gold: 361.65 },
  { min: 77.01, max: 78.00, standard: 523.370, silver: 471.03, gold: 366.36 },
  { min: 78.01, max: 79.00, standard: 530.090, silver: 477.08, gold: 371.06 },
  { min: 79.01, max: 80.00, standard: 536.820, silver: 483.14, gold: 375.77 },
  { min: 80.01, max: 81.00, standard: 543.550, silver: 489.19, gold: 380.48 },
  { min: 81.01, max: 82.00, standard: 550.270, silver: 495.24, gold: 385.19 },
  { min: 82.01, max: 83.00, standard: 557.000, silver: 501.30, gold: 389.90 },
  { min: 83.01, max: 84.00, standard: 563.720, silver: 507.35, gold: 394.60 },
  { min: 84.01, max: 85.00, standard: 570.450, silver: 513.41, gold: 399.31 },
  { min: 85.01, max: 86.00, standard: 577.180, silver: 519.46, gold: 404.03 },
  { min: 86.01, max: 87.00, standard: 583.900, silver: 525.51, gold: 408.73 },
  { min: 87.01, max: 88.00, standard: 590.630, silver: 531.57, gold: 413.44 },
  { min: 88.01, max: 89.00, standard: 597.350, silver: 537.62, gold: 418.14 },
  { min: 89.01, max: 90.00, standard: 604.080, silver: 543.67, gold: 422.86 },
  { min: 90.01, max: 91.00, standard: 610.810, silver: 549.73, gold: 427.57 },
  { min: 91.01, max: 92.00, standard: 617.530, silver: 555.78, gold: 432.27 },
  { min: 92.01, max: 93.00, standard: 624.260, silver: 561.83, gold: 436.98 },
  { min: 93.01, max: 94.00, standard: 630.980, silver: 567.88, gold: 441.69 },
  { min: 94.01, max: 95.00, standard: 637.710, silver: 573.94, gold: 446.40 },
  { min: 95.01, max: 96.00, standard: 644.440, silver: 580.00, gold: 451.11 },
  { min: 96.01, max: 97.00, standard: 651.160, silver: 586.04, gold: 455.81 },
  { min: 97.01, max: 98.00, standard: 657.890, silver: 592.10, gold: 460.52 },
  { min: 98.01, max: 99.00, standard: 664.610, silver: 598.15, gold: 465.23 },
  { min: 99.01, max: 100.00, standard: 671.340, silver: 604.21, gold: 469.94 }
];
